/* 興味関心チェック・印刷 */
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';
import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import { JS_VOID } from '../utils/commonUtil';
import { BrowserHandler } from './InterestCheckPrintBrowsers/BrowserHandler';

interface InterestCheckPrintProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;

  // 前ページのユーザーID.
  match?: any;
}

interface InterestCheckPrintState {
  currentPage: number;
}

class InterestCheckPrint extends React.Component<InterestCheckPrintProps, InterestCheckPrintState> {
  static propTypes = {
    moffAPI: PropTypes.any.isRequired,
    moffAPIActions: PropTypes.any.isRequired,
  };

  // 全シーケンス数.
  total: number;

  // ユニークID.
  uniqueId: string;

  // 現在のシーケンス数.
  currnetSequence: number;

  componentWillMount() {
    document.title = '興味関心チェックシート';

    this.props.headerActions.setPage(Header.INTEREST_CHECK_PRINT);

    // URLのパラメータ.
    this.total = this.props.match.params.total;
    const userId = this.props.match.params.userId;
    this.uniqueId = this.props.match.params.uniqueId;

    // 記録番号.
    this.currnetSequence = this.total;

    this.setState(
      {currentPage: this.currnetSequence}
    );

    // 最初だけユーザのIDを取りたいので.
    this.runAPI(userId);
  }

  /**
   * APIの実行.
   * @method runAPI
   * @param {string} userId ユーザID.
   */
  runAPI(userId: string = '') {
    // Action
    this.props.moffAPIActions.getInterestCheckRecord(userId, this.uniqueId, this.currnetSequence);
  }

  renderCSS(): JSX.Element {
    return (
      <style type="text/css">
      {'#interestcheck { padding-left: 1.0cm; padding-right: 1.0cm; }'}

      {/* 表の調整 */}
      {'body,div,table,thead,tbody,tfoot,tr,th,td,p { font-size:small }'}

      {/* 上の影響を吸収 */}
      {'h1, .prev { font-size:120%; line-height: 1.75;}'}

      {/* Chromeでのtrの背景表示のため */}
      {'body { -webkit-print-color-adjust: exact; }'}
      {'a.comment-indicator:hover + comment { background:#ffd; ' +
      'position:absolute; display:block; border:1px solid black; padding:0.5em; }'}
      {'a.comment-indicator { background:red; display:inline-block; ' +
      'border:1px solid black; width:0.5em; height:0.5em; }'}
      {'comment { display:none; } '}
      </style>
    );
  }

  // 左をクリックしたときの処理.
  pushLeft = () => {
    this.currnetSequence--;
    this.setState(
      {currentPage: this.currnetSequence}
    );
    this.runAPI();
  }

  // 右をクリックしたときの処理.
  pushRight = () => {
    this.currnetSequence++;
    this.setState(
      {currentPage: this.currnetSequence}
    );
    this.runAPI();
  }

  /**
   * 印刷ボタンの描画.
   * @method renderPrint
   * @return {JSX.Element} JSX.
   */
  renderPrint(): JSX.Element {
    return (
      <section id="sec01" className="kiroku_edit_tpl">
        <div className="edit-btn btnStyle00">
          <button
            onClick={event => {window.print(); return false; }}
          >
            印刷
          </button>
        </div>
        <div className="calendarHeader">
          <div className="dateArea">
            <div className="date">
              {this.currnetSequence} / {this.total}
            </div>
            { this.currnetSequence <= 1 ? (null) :
              <div className="btn left">
                <a
                  href={JS_VOID}
                  onClick={event => this.pushLeft()}
                />
              </div>
            }
            { this.currnetSequence >= this.total ? (null) :
              <div className="btn right">
                <a
                  href={JS_VOID}
                  onClick={event => this.pushRight()}
                />
              </div>
            }
          </div>
        </div>
        <br />
      </section>
    );
  }

  render() {
    return (
      <div id="interestcheck" style={{backgroundColor: 'white'}}>
        {
          (() => {
            if (this.props.moffAPI.Loaded) {
              return;
            }

            // ローディング中.
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        <BrowserHandler moffAPI={this.props.moffAPI} total={this.total} />

        {this.renderPrint()}
        {this.renderCSS()}
      </div>
    );
  }
}

export default InterestCheckPrint;


// WEBPACK FOOTER //
// ./src/components/InterestCheckPrint.tsx